import { Section } from '@/components/Section';
import { events, track } from '@/lib/analytics';

const PHONE_DISPLAY = '(972) 977-5605';
const PHONE_TEL = 'tel:+19729775605';

export function ContactPage() {
  return (
    <Section eyebrow="Get in touch" title="Call us.">
      <div className="grid max-w-2xl gap-6">
        <p className="text-bone/70">
          The fastest way to reach the gym is by phone. Front-desk staff can answer questions about
          programs, schedule, drop-ins, and pricing.
        </p>
        <a
          href={PHONE_TEL}
          onClick={() => track(events.contactSubmit, { method: 'tel' })}
          className="btn-primary inline-flex items-center justify-center gap-3 px-8 py-5 text-lg sm:w-fit"
          aria-label={`Call the gym at ${PHONE_DISPLAY}`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="h-5 w-5"
            aria-hidden="true"
          >
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
          </svg>
          Call {PHONE_DISPLAY}
        </a>
        <div className="text-sm text-bone/60">
          <p>612 Valley Ranch Pkwy S · Irving, TX 75063</p>
          <p className="mt-1">
            Billing questions:{' '}
            <a href="tel:+18882774408" className="text-accent hover:underline">
              (888) 277-4408
            </a>
          </p>
        </div>
      </div>
    </Section>
  );
}
